<template>
  <div>
    <v-img class="background" lazy-src="../assets/background-image-1.png" src="../assets/background-image-1.png"
      height="92.3vh">
      <v-container fill-height fluid>
        <v-row align="center" justify="center">
          <v-spacer />
          <v-col :cols="colWidth">
            <v-card height="fit-content" min-height="17vh" class="text-center d-flex align-center justify-center">
              <v-container fill-height fluid class="card">
                <v-row align="center" justify="center">
                  <v-spacer />
                  <v-col cols="11">
                    IHR VERMÖGEN IN VERANTWORTUNGSVOLLEN HÄNDEN
                  </v-col>
                  <v-spacer />
                </v-row>
              </v-container>
            </v-card>
          </v-col>
          <v-spacer />
        </v-row>
      </v-container>
    </v-img>

    <!-- __________________Neuer Kontakt Versuch_____________________________________________________________________________________________________________________________________________________ -->

    <v-container class="row2" justify="center" fluid>
      <v-row>
        <v-spacer v-if="!isMobile && listCol == 3" />
        <v-spacer v-if="!isMobile" />
        <v-col :cols="imageCol">
          <v-img class="map" lazy-src="../assets/map.png" src="../assets/map.png" :height="imageHeight">
          </v-img>
        </v-col>
        <v-spacer v-if="!isMobile" />
        <v-col class="list1" :class="{marginTop: !isMobile}" :cols="listCol">
          <h1 id="row1">Kontakt</h1>
          <br />
          <p>Wipev GmbH</p>
          <!-- <p>GF:N.Peters</p> -->
          <p>Querallee 38</p>
          <p>34119 Kassel</p>
          <p>
            <a href="tel:+4956122076942" style="color: #44546a; text-decoration: none">Tel: 0561-22076942</a>
          </p>
          <p>
            <a href="mailto:info@wipev.gmbh" style="color: #44546a; text-decoration: none">Email: info@wipev.gmbh</a>
          </p>
        </v-col>
        <v-spacer v-if="!isMobile" />
        <v-spacer v-if="!isMobile && listCol == 3" />
      </v-row>
    </v-container>

    <!-- __________________Neuer Kontakt Versuch: Ende_____________________________________________________________________________________________________________________________________________________ -->

    <v-container class="row2" justify="center" fluid>
      <v-row :style="{'flex-direction': isMobile ? 'column-reverse' : 'initial'}">
        <v-spacer v-if="listCol == 3" />
        <v-spacer />
        <v-col class="list2" :cols="listCol">
          <br />
          Wir sind eine Hausverwaltung mit Sitz im schönen Vorderen Westen in Kassel und der Schwerpunkt unserer
          Tätigkeit liegt in der Verwaltung von kleineren und mittelgroßen Mietobjekten sowie von
          Wohnungseigentümergemeinschaften (WEG) und dem Verkauft und Vermietung von Immobilien. <br>
          <br>
          Wir legen besonderen Wert auf eine persönliche Betreuung und Transparenz gegenüber unseren Kunden. <br>
          <br>
          Unsere Arbeitsweise ist nahezu vollständig digitalisiert und wir streben eine kontinuierliche
          Weiterentwicklung an.
          <br />
          <br />
          <br />
          <h2>WEG- Verwaltung</h2>
          <ul>
            <li>Technische, wirtschaftliche und kaufmännische Betreuung von Immobilien</li>
            <li>Umsetzung der Beschlüsse der Wohnungseigentümer</li>
            <li>Aufstellung eines Wirtschaftsplanes für jedes Kalenderjahr</li>
            <li>Erstellung einer Jahresabrechnung nach Ablauf des Kalenderjahres</li>
            <li>Organisation von Eigentümerversammlungen und Zusammenarbeit mit den Beiräten der Eigentümergemeinschaft
            </li>
            <li>Korrespondenz und Verträge mit Handwerkern, Dienstleistern</li>
            <li>Mahnwesen bei Zahlungsverzug von Hausgeld</li>
            <li>Regelmäßige Objektkontrolle inklusive Instandhaltungs- und Instandsetzungsplanung</li>
          </ul>
        </v-col>
        <v-spacer />
        <v-col :cols="imageCol" style="display: flex; align-items: center">
          <v-img class="map" lazy-src="../assets/office-1.png" src="../assets/office-1.png">
          </v-img>
        </v-col>
        <v-spacer />
        <v-spacer v-if="listCol == 3" />
      </v-row>
    </v-container>

    <v-container class="row2" justify="center" fluid>
      <v-row>
        <v-spacer v-if="!isMobile && listCol == 3" />
        <v-spacer v-if="!isMobile" />
        <v-col :cols="imageCol" style="display: flex; align-items: center">
          <v-img class="map" lazy-src="../assets/office-2.png" src="../assets/office-2.png">
          </v-img>
        </v-col>
        <v-spacer />
        <v-col class="list2" :cols="listCol">
          <h2>Sondereigentumsverwaltung</h2>
          <ul>
            <li>Betreuung von vermieteten Eigentumswohnungen in der Eigentümergemeinschaft</li>
            <li>Kaufmännische und technische Verwaltung, wie z. B. Betreuung von Mietern und Erstellung von Mietverträgen, Neuvermietung der Eigentumswohnung, Abrechnung der Betriebs- und Heizkosten</li>
          </ul>
          <br />
          <br />
          <h2>Mietverwaltung</h2>
          <ul>
            <li>Führung sämtlichen Schriftwechsels mit Mietern und Eigentümern</li>
            <li>Buchführung inkl. Überwachung der Mietzahlungen </li>
            <li>Erstellung einer jährlichen Betriebskostenabrechnung mit den Mietern</li>
            <li>Begehung der Wohnanlage</li>
            <li>Überwachung der bestehenden Hausordnung</li>
            <li>Vermietung der Wohnung (inklusive Suche von Mietern, Erstellung Mietvertrag, Wohnungsabnahme- und
              Übergabe)</li>
          </ul>
          <br />
          <br />
          <h2>Abrechnungsservice</h2>
          <ul>
            <li>Erstellung der Betriebskostenabrechnung für Mieter (nach Vorlage aller Kostenbelege)</li>
          </ul>
          <br />
          <br />
          <h2>Maklertätigkeit</h2>
          <ul>
            <li>Verkauf von Immobilien</li>
            <li>Vermietung von Immobilien</li>
          </ul>
        </v-col>
        <v-spacer />
        <v-spacer v-if="listCol == 3" />
      </v-row>
    </v-container>
    

    <!-- ____________________________________________________old map____________________________________________________ -->

    <!-- <v-container class="row4" fluid>
      <v-row>
        <v-img class="map" lazy-src="../assets/map.png" src="../assets/map.png" height="40vh">
        </v-img>  
      </v-row>
    </v-container> -->

    <!-- ____________________________________________________Ende_____________________________________________________-->
  </div>
</template>

<script>
export default {
  computed: {
    imageHeight(){
      return "40vh"
    },
    colWidth() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 11;
        case "sm":
          return 10;
        case "md":
          return 8;
        case "lg":
          return 4;
        case "xl":
          return 4;
        default:
          return 4;
      }
    },
    listCol() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 3;
        default:
          return 3;
      }
    },
    imageCol() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 3;
        default:
          return 3;
      }
    },
    isMobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        default:
          return false;
      }
    },
  },
};
</script>